import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { MyFavouriteListContainer } from "./myFavouriteListContainer";
import { PAGES } from "../../../routeConfig";
import { MyFavoriteListEdit } from "./view/myFavoriteListEdit";
import { BacktoMyAccount } from "../backToMyAccount";
import $ from "jquery";
export const MyFavouriteProductMain = () => {
  const { listId } = useParams();
  const [editId, setEditId] = useState(null);
  const [breadData, setBreadData] = useState(null);
  useEffect(() => {
    if (listId) {
      setEditId(listId);
      setBreadData([
        { name: "My Account", url: "/myaccount" },
        { name: "My Favourite Products", url: PAGES.FAVORITEPRODUCT_LIST },
        { name: "Edit", url: "" },
      ]);
      $("#favouriteList").fadeOut();
      $("#favouriteEdit").fadeIn("slow");
    } else {
      setEditId(null);
      setBreadData([
        { name: "My Account", url: "/myaccount" },
        { name: "My Favourite Products", url: PAGES.FAVORITEPRODUCT_LIST },
      ]);
      $("#favouriteList").fadeIn("slow");
      $("#favouriteEdit").fadeOut();
    }
  }, [listId]);

  return (
    <Fragment>
      <BreadCrumb data={breadData} />
      <div id="favouriteList">
        <MyFavouriteListContainer />
      </div>
      <div id="favouriteEdit">
        <MyFavoriteListEdit listId={editId} />
      </div>
    </Fragment>
  );
};
